module.exports = __webpack_public_path__ + "static/media/opportunityDetailTitle.d28cef8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/opportunityDetailTitle.png
// module id = 1506
// module chunks = 0